import React from "react";

const Skeleton = ({ className }) => {
  return (
    <div
      role="status"
      className="max-w-sm animate-pulse flex items-center justify-center"
    >
      <div
        className={`bg-gray-200 rounded-full dark:bg-gray-700 h-10  w-10 ${className}`}
      ></div>
    </div>
  );
};

export default Skeleton;
